import { View, XStack } from 'tamagui';

interface ChecklistCompletionIndicatorProps {
    completedSteps: boolean[];
    indicatorColor: string;
    totalStepCount: number;
    /**
     * Controls whether completed steps are shown in the provided order ('in-place')
     * or from left-to-right like a progress meter ('left-to-right')
     */
    completedOrdering?: 'in-place' | 'progress';
}

export const ChecklistCompletionIndicator = (
    props: ChecklistCompletionIndicatorProps,
) => {
    const {
        completedSteps,
        indicatorColor,
        totalStepCount,
        completedOrdering = 'in-place',
    } = props;
    const countOfCompletedSteps = completedSteps.filter(
        (isComplete) => isComplete,
    ).length;
    return (
        <XStack height={6} width="100%" marginVertical={24} gap={8}>
            {Array.from({ length: totalStepCount }, (_, i) => {
                const isComplete =
                    completedOrdering === 'progress'
                        ? i + 1 <= countOfCompletedSteps
                        : completedSteps[i] === true;
                return (
                    <View
                        flex={1}
                        height="100%"
                        key={i}
                        borderRadius={100}
                        backgroundColor={
                            isComplete ? indicatorColor : '$gray400'
                        }
                    />
                );
            })}
        </XStack>
    );
};
